import classNames from 'classnames';
import type { ComponentProps, FC } from 'react';

const SectionSeparator: FC<ComponentProps<'div'>> = ({ className }) => (
  <div className={classNames('h-0.5 w-full bg-gray-100 my-10', className)} />
);

export default SectionSeparator;
